var _excluded = ["icon", "size", "isDisabled", "status", "badge", "aria-hidden"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Icon } from '../../../foundations/Icon';
import { isBrandSymbol } from '../../../theme/icons/utils';
import { forwardRef } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { BrandSymbol, StatusIndicator } from '../../dataDisplay';
import { _BaseIcon, _NotSupportedBadge, Box, iconColorMapping } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// TODO: change the name of the repo and theme
export var IconButton = forwardRef((props, ref) => {
  var {
    icon,
    size = 'large',
    isDisabled,
    status,
    badge,
    ['aria-hidden']: ariaHidden
  } = props,
      rest = _objectWithoutProperties(props, _excluded);

  var styles = useMultiStyleConfig('IconButton', props); // TODO: Add type guard and move not supported badge into the story https://meliorisk.atlassian.net/browse/ME-44254

  var isPrimaryNotSupportedState = (props.variant === 'primary' || props.variant === 'primaryInverted') && (size === 'small' || status || badge);
  var isNakedNotSupportedState = props.variant === 'naked' && size === 'small' && (status || badge);
  var isNakedInvertedNotSupportedState = props.variant === 'nakedInverted' && (status || badge);

  if (isPrimaryNotSupportedState || isNakedNotSupportedState || isNakedInvertedNotSupportedState) {
    return /*#__PURE__*/_jsx(_NotSupportedBadge, {
      details: {
        componentName: 'IconButton',
        props: {
          variant: 'primary',
          size: 'small'
        }
      }
    });
  }

  var iconButton = /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    "data-component": "IconButton",
    as: "button",
    tabIndex: isDisabled ? -1 : 0,
    type: "button"
  }, rest), {}, {
    // WE are using `disabled` prop for testing, we want the users to be able to use `toBeDisabled` on iconButton in unit tests.
    // WE are using `aria-disabled` for the theme.
    // ts-ignore is used due to `type` issues with `<Box/>`.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    disabled: isDisabled,
    "aria-disabled": isDisabled,
    __css: styles['container'],
    ref: ref,
    children: /*#__PURE__*/_jsxs(Box, {
      __css: styles['hitAreaContainer'],
      children: [/*#__PURE__*/_jsx(Icon, {
        type: icon,
        size: size,
        color: "inherit",
        "aria-hidden": ariaHidden
      }), badge && /*#__PURE__*/_jsx(Box, {
        __css: styles['badge'],
        "data-testid": "icon-button-badge",
        children: isBrandSymbol(badge) ? /*#__PURE__*/_jsx(BrandSymbol, {
          type: badge,
          size: "extra-small",
          isDisabled: isDisabled
        }) : /*#__PURE__*/_jsx(_BaseIcon, {
          type: badge,
          size: "extra-small",
          color: iconColorMapping[badge === 'verified' && 'brand' || 'default'],
          isDisabled: isDisabled
        })
      })]
    })
  }));

  return status ? /*#__PURE__*/_jsx(StatusIndicator, {
    status: status,
    isDisabled: isDisabled,
    children: iconButton
  }) : iconButton;
});
IconButton.displayName = 'IconButton';
//# sourceMappingURL=IconButton.js.map